import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../../i18n/I18nContext";

const PageTitle = ({
  title,
  titleKey,
  currentPage,
  currentPageKey,
  bgImage = "/img/bg/14.jpg",
  endContent = null,
  className = "",
}) => {
  const { t } = useI18n();
  const resolvedTitle = titleKey ? String(t(titleKey)) : title ?? "";
  const resolvedCurrent = currentPageKey ? String(t(currentPageKey)) : currentPage ?? resolvedTitle;

  return (
    <div
      className={`ltn__breadcrumb-area text-left bg-overlay-white-30 bg-image${className ? ` ${className}` : ""}${
        endContent ? " qtech-breadcrumb-has-filters" : ""
      }`}
      data-bs-bg={bgImage}
      style={{ backgroundImage: `url("${bgImage}")` }}
    >
      <div className={`container${endContent ? " position-relative" : ""}`}>
        {endContent ? <div className="qtech-page-filters-floated">{endContent}</div> : null}
        <div className="row">
          <div className="col-lg-12">
            <div className="ltn__breadcrumb-inner">
              <h1 className="page-title">{resolvedTitle}</h1>
              <div className="ltn__breadcrumb-list">
                <ul>
                  <li>
                    <Link to="/">
                      <span className="ltn__secondary-color">
                        <i className="fas fa-home" />
                      </span>{" "}
                      {t("breadcrumb.home")}
                    </Link>
                  </li>
                  <li>{resolvedCurrent}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageTitle;
